import * as Yup from 'yup';
import { notAllowedWord, reservedValues } from '../formElements/reservedKeywords';
export const FilterSchema = {
  name: '',
  primaryQuery: '',
  selectedIncludeField: '',
  selectedExcludeField: '',
  aggregateFunctionField: '',
  selectSortField: { label: 'Created At', value: 'createdAt' },
  selectOrderBy: { label: 'Ascending', value: 'asc' },
  isPrivate: true,
  enableRls: false,
  rlsFilter: '',
  addTenantQuery: false,
  addSubTenantQuery: false,
  derivedFieldMapping: '',
};
export const FilterSchemaValidation = Yup.object().shape({
  primaryQuery: Yup.object().required("Query can't be blank"),
  name: Yup.string()
    .required("Name can't be blank")
    .matches(/^[0-9A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
    .max(100, 'Name can not be more than 100 characters')
    .test('reserved', 'This is reserved word please use another', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !reservedValues.includes(lowercaseValue);
    })
    .test('not-allowed', 'This type of word not allowed.', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !notAllowedWord.includes(lowercaseValue);
    }),
});

export const RowLevelSecurityFilterSchemaValidation = Yup.object().shape({
  name: Yup.string()
    .required("Name can't be blank")
    .matches(/^[0-9A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
    .max(100, 'Name can not be more than 100 characters')
    .test('reserved', 'This is reserved word please use another', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !reservedValues.includes(lowercaseValue);
    })
    .test('not-allowed', 'This type of word not allowed.', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !notAllowedWord.includes(lowercaseValue);
    }),
});
